var _style, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "-320 587.3 608.9 76.7",
    style: {
      enableBackground: "new -320 587.3 608.9 76.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "XMLID_94_",
    x: -320,
    y: 587.3,
    width: 608.9,
    height: 76.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_358_",
    className: "st0",
    d: "M-291.5,657.9v-64.5h7.2v14.3l14.3-14.3h14.3v21.5h-21.4c-3.9,0-7.2,3.2-7.2,7.2v7.2 c0,4,3.1,7.2,7.2,7.2h21.5V658H-270l-14.3-14.5v14.3L-291.5,657.9L-291.5,657.9z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_355_",
    className: "st0",
    d: "M-248.5,657.9v-57.4c0-3.9,3.2-7.2,7.2-7.2h21.5c3.9,0,7.2,3.4,7.2,7.2v57.3h-7.2v-28.6h-21.5 v28.7C-241.3,657.9-248.5,657.9-248.5,657.9z M-219.8,622c0-3.8-3.4-7.2-7.2-7.2h-7.2c-3.9,0-7.2,3.2-7.2,7.2H-219.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_353_",
    className: "st0",
    d: "M-205.5,657.9v-21.5h7.2v-21.5h-7.2v-21.5h21.5v21.5h-7.2v21.5h7.2v21.5H-205.5z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_351_",
    className: "st0",
    d: "M-176.8,587.3h7.2v14.3c0,4-3.2,7.2-7.2,7.2V587.3z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_349_",
    className: "st0",
    d: "M-162.5,657.9v-21.5h25.1c2,0,3.6-1.7,3.6-3.6s-1.7-3.6-3.6-3.6h-17.9c-4,0-7.2-3.1-7.2-7.2 v-21.5c0-3.9,3.2-7.2,7.2-7.2h28.7v21.5h-25.2c-2,0.2-3.5,1.6-3.5,3.6c0,2.1,1.5,3.6,3.6,3.6h17.9c3.9,0,7.2,3.4,7.2,7.2v21.5 c0,4-3.2,7.2-7.2,7.2H-162.5z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_345_",
    className: "st0",
    d: "M-98,657.9v-64.5h28.7c3.9,0,7.2,3.4,7.2,7.2v21.5c0,1.9-1.6,3.6-3.6,3.6 c1.9,0,3.6,1.7,3.6,3.6v21.5c0,4-3.2,7.2-7.2,7.2H-98V657.9z M-72.9,622c2,0,3.6-1.7,3.6-3.6c0-1.9-1.7-3.6-3.6-3.6h-17.9v7.2H-72.9 z M-72.9,636.4c2,0,3.6-1.7,3.6-3.6s-1.7-3.6-3.6-3.6h-17.9v7.2C-90.8,636.4-72.9,636.4-72.9,636.4z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_342_",
    className: "st0",
    d: "M-47.8,657.9c-4,0-7.2-3.1-7.2-7.2v-50.2c0-3.9,3.2-7.2,7.2-7.2h21.5c3.9,0,7.2,3.4,7.2,7.2 v50.2c0,4-3.2,7.2-7.2,7.2H-47.8z M-33.5,636.4c3.9,0,7.2-3.2,7.2-7.2V622c0-3.8-3.4-7.2-7.2-7.2h-7.2c-3.9,0-7.2,3.2-7.2,7.2v7.2 c0,4,3.1,7.2,7.2,7.2H-33.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_339_",
    className: "st0",
    d: "M-12,657.9v-57.4c0-3.9,3.2-7.2,7.2-7.2h21.5c3.9,0,7.2,3.4,7.2,7.2v57.3h-7.2v-28.6H-4.8v28.7 C-4.8,657.9-12,657.9-12,657.9z M16.7,622c0-3.8-3.4-7.2-7.2-7.2H2.3c-3.9,0-7.2,3.2-7.2,7.2H16.7z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_337_",
    className: "st0",
    d: "M45.4,657.9v-43H31.1v-21.5h35.8v21.5H52.6v43H45.4z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_335_",
    className: "st0",
    d: "M95.6,657.9v-64.5h35.8v21.5h-28.7v7.2h21.5v7.2h-21.5V658h-7.1V657.9z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_333_",
    className: "st0",
    d: "M145.7,657.9c-4,0-7.2-3.1-7.2-7.2v-57.3h7.2v35.8c0,4,3.1,7.2,7.2,7.2h7.2 c3.9,0,7.2-3.2,7.2-7.2v-35.8h7.2v57.3c0,4-3.2,7.2-7.2,7.2H145.7z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_331_",
    className: "st0",
    d: "M181.6,657.9v-64.5h14.3c3.9,0,7.2,3.4,7.2,7.2v32.3c0,2.1,1.5,3.6,3.6,3.6 c2,0,3.6-1.7,3.6-3.6v-39.5h7.2v64.5h-14.3c-4,0-7.2-3.1-7.2-7.2v-32.2c0-1.9-1.7-3.6-3.6-3.6c-1.9,0-3.6,1.6-3.6,3.6v39.4 C188.8,657.9,181.6,657.9,181.6,657.9z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_328_",
    className: "st0",
    d: "M224.6,657.9v-64.5h28.7c3.9,0,7.2,3.4,7.2,7.2v50.2c0,4-3.2,7.2-7.2,7.2h-28.7V657.9z  M246.1,636.4c3.9,0,7.2-3.2,7.2-7.2V622c0-3.8-3.4-7.2-7.2-7.2h-14.3v21.5L246.1,636.4L246.1,636.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.cb41835df7c9e0e2e70dc5c3d9161095.svg";
export { ForwardRef as ReactComponent };